<template>
    <footer class="wl-footer">
        <div class="container">
            <div class="row">
                <div class="col-md-4 mb-4">
                    <router-link :to="{ name: 'Home'}">
                        <!-- Used CSS filter to make logo white on dark bg -->
                        <img src="/images/logo.png" class="img-fluid" alt="Diverse Care Now" style="max-height: 80px; filter: brightness(0) invert(1);" />
                    </router-link>
                    <p class="text-white mt-4" style="font-family: var(--wl-font-body); opacity: 0.8; font-size: 14px;">
                        2700 NE 14TH ST#101<br/>
                        POMPANO BEACH-FL 33062
                    </p>
                    <p class="text-white mt-2" style="font-family: var(--wl-font-body); opacity: 0.8; font-size: 14px;">
                        300 TRADECENTER DR #4400<br/>
                        WOBURN, MA 01801
                    </p>
                </div>

                <div class="col-md-4 mb-4">
                    <h5 class="wl-footer-heading">{{ $t('footer.quickLinks') }}</h5>
                    <ul class="wl-footer-links">
                        <li>
                            <router-link :to="{ name: 'Home'}">{{ $t('links.home') }}</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'Mission'}">{{ $t('links.mission') }}</router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'Payment Plans'}">{{ $t('links.paymentPlans') }}</router-link>
                        </li>
                        <li>
                            <a href="/privacy">{{ $t('links.privacy') }}</a>
                        </li>
                    </ul>
                </div>

                <div class="col-md-4 mb-4">
                    <h5 class="wl-footer-heading">{{ $t('contact.title') }}</h5>
                    <ul class="wl-footer-links">
                        <li>
                            <a href="https://diversecarenow.as.me/schedule/6a240cde" target="_blank">
                                <i class="bi-calendar-check me-2"></i>{{ $t('footer.bookAppointment') }}
                            </a>
                        </li>
                        <li><a href="https://wa.me/17542761746" target="_blank"><i class="bi-whatsapp me-2"></i>{{ $t('contact.WhatsappMsg') }}</a></li>
                        <li><a href="tel:+17547521888"><i class="bi-telephone me-2"></i>{{ $t("contact.Call") }}</a></li>
                        <li><a href="mailto:patientcare@diversecarenow.com"><i class="bi-envelope me-2"></i>patientcare@diversecarenow.com</a></li>
                    </ul>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-12">
                    <p class="text-white-50 small text-center">{{ $t('footer.footerDisclaimer') }}</p>
                </div>
            </div>

            <div class="wl-footer-bottom">
                <p>
                    Copyright &copy; {{ year }}
                    <strong>Diverse Care Now</strong>
                    - v{{ version }}
                    <a href="https://www.instagram.com/diversecarenow/?igshid=YmMyMTA2M2Y%3D" target="_blank" class="ms-3 text-white" style="font-size: 1.2rem;"><i class="bi-instagram"></i></a>
                </p>
            </div>
        </div>
    </footer>
</template>
<script>
import pkg from '../../package.json'
const version = pkg.version
export default {
  name: 'FooterLayout',
  setup() {
        const year = new Date().getFullYear()
        return { version, year }
    }
}
</script>